<!-- 底部 -->
<template>
<div class="footer" v-if="activeName!='writing'">
    <div class="footer_box">
        <div class="menu">
            <ul v-for="(item, index) in list" :key="index">
                <li v-for="(items, i) in item" :class="{'cur': items.cur}" :key="i" @click="golink(items.path,items.name)">
                    {{ items.name }}
                    <img v-if="items.img" src="/static/images/mcode.png" alt="" srcset="" />
                    <img v-if="items.img" :src="contactList.wxUrl" alt="" class="wxImg">
                </li>
            </ul>
        </div>
        <div class="code_box">
            <img :src="appDownImg" alt="" srcset="" />
            <p class="dow">笔杆论文APP</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      activeName: '',
      list: [
        [{
          name: '友情链接',
          path: ''
        },
        {
          name: 'PaperYY论文查重',
          path: 'https://www.paperyy.com/',
          cur: true
        },
        {
          name: '论文免费下载',
          path: 'https://www.ixueshu.com/',
          cur: true
        },
        {
          name: '免费PPT模板下载',
          path: 'http://ppt.ixueshu.com/',
          cur: true
        },
        {
          name: '免费图书下载',
          path: 'https://book.ixueshu.com/',
          cur: true
        }
        ],
        [{
          name: '联系我们',
          path: ''
        },
        {
          name: '微信客服',
          path: '',
          img: true,
          cur: true
        },
        {
          name: '邮箱：service@bigan.net',
          path: '',
          cur: false
        },
        {
          name: '联系电话：027-59763989',
          path: '',
          cur: false
        }
        ],
        [{
          name: '关于',
          path: ''
        },
        {
          name: '关于我们',
          path: '/page/about',
          cur: true
        },
        {
          name: '服务条款',
          path: '/page/terms_of_service',
          cur: true
        }
          // {
          //     name: "反馈问题",
          //     path: ""
          // }
        ]
      ],
      contactList: {},
      appDownImg: ''
    }
  },
  methods: {
    golink (path, name) {
      switch (name) {
        case 'PaperYY论文查重':
          window.open(path, '_black')
          break
        case '论文免费下载':
          window.open(path, '_black')
          break
        case '免费PPT模板下载':
          window.open(path, '_black')
          break
        case '免费图书下载':
          window.open(path, '_black')
          break
        case '关于我们':
          this.$router.push(path)
          break
        case '服务条款':
          this.$router.push(path)
          break
      }
    },
    // 联系方式
    getContact () {
      this.oauthapi.contact().then(res => {
        this.contactList = res.data
        for (let i in this.list) {
          this.list[1][2].name = '邮箱：' + res.data.email
          this.list[1][3].name = '联系电话：' + res.data.mobile
        }
      })
    },
    // app下载二维码
    getAppDownImg () {
      let keyParams = {
        key: 'app_download_img_url'
      }
      this.oauthapi.appdownImg(keyParams).then(res => {
        this.appDownImg = res.data.setValue
      })
    }

  },
  created: function () {
    this.activeName = this.$route.name
    // this.getContact()
    //this.getAppDownImg()
  },
  watch: {
    $route: {
      /**
             *  监听路由变化 隐藏底部导航栏
             *   val; 新路由信息
             *   oldval 老路由信息
             *
             */
      handler: function (val, oldval) {
        this.activeName = val.name
      },
      // 深度观察监听
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
    background: #272d36;
    padding: 50px 0;

    .footer_box {
        width: $mWidth;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .menu {
            display: flex;

            ul {
                padding: 0;
                margin-right: 10rem;

                li {
                    margin-bottom: 0.5rem;
                    font-size: 1rem;
                    color: #bdbec0;
                    font-weight: 700;
                    line-height: 2rem;
                    height: 2rem;

                    img {
                        width: 1.5rem;
                        margin-bottom: -0.1rem;
                    }

                    .wxImg{
                       width: 9rem;
                       position: absolute;
                       display: none;
                       margin-left: 5px;
                       z-index: 2;
                    }

                    &:hover{
                      .wxImg{
                        display: inline-block;
                      }
                    }
                }
                .cur{
                  cursor: pointer;
                }

                li:first-child {
                    font-size: 1.4rem !important;
                    color: #666666 !important;
                    margin-bottom: 2.5rem;
                }
            }
        }

        .code_box {
            img{
                display: block;
                width: 104px;
            }
            .dow {
                margin-top: 1.2rem;
                text-align: center;
                color: #BDBEC0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue